// extracted by mini-css-extract-plugin
export default {"content":"CollectionPointsPage_content__SmXrY"};